import { Alert } from "@abbiamo/ui";
import { X } from "lucide-react";
import * as React from "react";

export type PortalToastCode =
  | "no-active-sellers-in-context"
  | "no-access-to-requested-context";

const TOAST_MESSAGES: Record<PortalToastCode, string> = {
  "no-active-sellers-in-context":
    "Voce nao possui acesso a nenhuma loja ativa nesta operacao.",
  "no-access-to-requested-context":
    "Esta conta nao tem acesso ao ambiente anterior. Escolha uma das operacoes abaixo.",
};

export const getPortalToastCode = (
  value: string | null,
): PortalToastCode | null =>
  value === "no-active-sellers-in-context" ? value : null;

export const removePortalToastErrorFromUrl = (href: string): URL => {
  const url = new URL(href);
  url.searchParams.delete("error");
  // Roda junto com o toast, ou seja, no caminho em que o usuario FICA na tela
  // de selecao. Sem limpar o sg, um refresh reprocessaria o mesmo pedido negado
  // e ele veria o toast de novo sem entender por que.
  url.searchParams.delete("sg");
  return url;
};

export const PortalToast = ({
  code,
  onClose,
}: {
  code: PortalToastCode;
  onClose: () => void;
}) => {
  React.useEffect(() => {
    const timeoutId = window.setTimeout(onClose, 6000);
    return () => window.clearTimeout(timeoutId);
  }, [onClose]);

  return (
    <div
      className="fixed inset-x-ab-4 top-ab-4 z-50 mx-auto max-w-[26rem] animate-ab-slide-down sm:inset-x-auto sm:right-ab-6 sm:top-ab-6"
      data-ui="toast"
    >
      <div className="relative">
        <Alert variant="error">{TOAST_MESSAGES[code]}</Alert>
        <button
          type="button"
          onClick={onClose}
          aria-label="Fechar aviso"
          className="absolute right-ab-2 top-ab-2 flex h-7 w-7 items-center justify-center rounded-full text-ab-fg-muted transition-colors duration-ab-fast hover:bg-ab-muted hover:text-ab-fg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ab-ring focus-visible:ring-offset-2 focus-visible:ring-offset-ab-bg"
        >
          <X size={16} aria-hidden />
        </button>
      </div>
    </div>
  );
};
